import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { delimiterSeparatedToTitleCase } from 'Utils';
import NavSideBarListItem from './NavSideBarListItem';
import NavSideBarListSectionHeader from './NavSideBarListSectionHeader';

const spanButtonStyle = {
  display: 'inline-block',
  verticalAlign: 'middle',
  paddingLeft: '15px',
};

const DROPDOWN_ARROW_WIDTH = 10;


export default class NavSideBarListSectionWithDropDown extends React.PureComponent {
  constructor(props) {
    super(props);

    this.getCategoryListItem = this.getCategoryListItem.bind(this);
    this.getNavSideBarListSection = this.getNavSideBarListSection.bind(this);

    this.onClick = this.onClick.bind(this);
    this.onStepInSection = this.onStepInSection.bind(this);
    this.isOpen = this.isOpen.bind(this);

    this.state = {
      openManually: false,
      open: this.onStepInSection(),
    };
  }

  onClick() {
    this.setState({
      openManually: true,
      open: !this.isOpen(),
    });
  }

  onStepInSection() {
    return (
      this.props.offsetIdx <= this.props.onStep &&
      this.props.onStep < (this.props.offsetIdx + this.props.sections.length)
    );
  }

  getCategoryListItem(section, screenIdx) {
    const sectionTitleCase = delimiterSeparatedToTitleCase('_', section);
    const isOpen = this.isOpen();
    const className = classnames('nav-header-dropdown-list-item', {
      active: this.props.onStep === screenIdx,
      hidden: !isOpen,
    });

    return (
      <NavSideBarListItem
        className={className}
        documentType={this.props.documentType}
        key={section}
        loadStaticBuilderSection={this.props.loadStaticBuilderSection}
        offsiteBuilder={this.props.offsiteBuilder}
        screenIdx={screenIdx}
        section={sectionTitleCase}
        title={(screenIdx + 1).toString()}
      />
    );
  }

  getNavSideBarListSection() {
    const navSideBarListSection = [];
    const numOfSections = this.props.sections.length;
    for (let i = 0; i < numOfSections; i += 1) {
      const section = this.props.sections[i];
      const screenIdx = this.props.offsetIdx + i;
      const navSideBarListItem = this.getCategoryListItem(section, screenIdx);
      navSideBarListSection.push(navSideBarListItem);
    }

    return navSideBarListSection;
  }

  isOpen() {
    const openAutomatically = (
      !this.state.openManually && this.onStepInSection()
    );

    return (
      (this.state.openManually && this.state.open) ||
      (!this.state.openManually && openAutomatically)
    );
  }

  render() {
    const navSideBarListSection = this.getNavSideBarListSection();
    const categoryTitleCase = delimiterSeparatedToTitleCase('_', this.props.category).trim();
    const screenIdx = this.props.offsetIdx + this.props.sections.length;
    const lastSection = this.props.isLastSectionGetLink ? 'get_link' : 'request_signature';
    const requestSignatureNavSideBarListItem = this.getCategoryListItem(lastSection, screenIdx);

    const imageStyles = {
      width: DROPDOWN_ARROW_WIDTH,
      verticalAlign: 'middle',
      transform: 'rotate(0deg)',
    };

    if (this.isOpen()) {
      imageStyles.transform = 'rotate(90deg)';
    }

    return (
      <React.Fragment
        key={categoryTitleCase}
      >
        <NavSideBarListSectionHeader
          key={`${categoryTitleCase}_heading`}
          onClick={this.onClick}
        >
          <img
            className="nav-header-dropdown-button-img"
            alt={this.isOpen() ? 'Click to close' : 'Click to open'}
            style={imageStyles}
            src={`${window.cdnUrl}/images/arrows/arrow-large.png`}
          />
          <span
            className="nav-header-dropdown-button-text"
            style={spanButtonStyle}
          >
            {this.props.category}
          </span>
        </NavSideBarListSectionHeader>

        {navSideBarListSection}
        {this.props.showRequestSignature &&
          requestSignatureNavSideBarListItem
        }

      </React.Fragment>
    );
  }
}


NavSideBarListSectionWithDropDown.defaultProps = {
  category: PropTypes.string,
  isLastSectionGetLink: false,
  showRequestSignature: false,
  sections: [],
  offsiteBuilder: false,
};

NavSideBarListSectionWithDropDown.propTypes = {
  category: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  isLastSectionGetLink: PropTypes.bool,
  loadStaticBuilderSection: PropTypes.func.isRequired,
  offsetIdx: PropTypes.number.isRequired,
  offsiteBuilder: PropTypes.bool,
  onStep: PropTypes.number.isRequired,
  sections: PropTypes.arrayOf(PropTypes.string),
  showRequestSignature: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/NavSideBarList/NavSideBarListSectionWithDropDown.jsx